import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { truncateText, formatDate, getData, apiUrl } from "../util";
import QueueItem from "../components/QueueItem";
import QueueNav from "../components/QueueNav";
import QueueCompanyFilter from "../components/QueueCompanyFilter";
import TagSearch from "../components/TagSearch";
import request from "request";
class ProblemQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      tlds: [],
      allItems: [],
      company: null,
      important: false,
      customers: [],
    };
  }
  componentDidMount() {
    this.getData();
    return;
  }
  getData = () => {
    request(
      {
        url: `${apiUrl}/queue/broken_urls`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        this.setState({
          items: json,
        });
      }
    );
  };
  remove = id => {
    this.setState({
      items: [],
    });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  render() {
    const { user } = this.props;
    const { items } = this.state;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    return (
      <div>
        <h1>URL Queue</h1>
        <QueueNav selected="problem" />
        {items &&
          items.map(item => (
            <QueueItem
              item={item}
              remove={this.remove}
              qType="problem"
              id={item.id}
              user={this.props.user}
              callback={this.getData}
            />
          ))}
      </div>
    );
  }
}

export default ProblemQueue;
